export default "__VITE_ASSET__BoWlilHJ__"